import { createAnalysisPage } from '@/features/analysisPage/components/AnalysisPageFactory';

export const AnalysisProductsPage = createAnalysisPage({
  type: 'product',
  baseRoute: '/analysis/products',
});
